/*
 * <bundle-builder> — "Stel je eigen tegelset samen".
 * Selecteer meerdere tegels en voeg ze in één keer toe als gegroepeerde regels (line-item
 * property _bundle). De staffelkorting komt van een Shopify AUTOMATISCHE korting (Admin → Kortingen);
 * dit component toont alleen de voortgang. Hergebruikt de globals routes/fetchConfig/publish.
 */
(function () {
  class BundleBuilder extends HTMLElement {
    connectedCallback() {
      this.min = parseInt(this.dataset.min, 10) || 1;
      this.cartAddUrl = this.dataset.cartAddUrl || '/cart/add';
      this.cartUrl = this.dataset.cartUrl || '/cart';
      this.bundleLabel = this.dataset.bundleLabel || 'Eigen set';
      this.moneyFormat = this.dataset.moneyFormat || '€{{amount}}';
      // Labels come from the theme locales (sections.bundle_builder.*) via data attributes.
      this.labels = {
        add: this.dataset.labelAdd || 'Add',
        chosen: this.dataset.labelChosen || 'Chosen',
        min: this.dataset.labelMin || '',
        next: this.dataset.labelNext || '[left] more for [label]',
        top: this.dataset.labelTop || '[label] unlocked',
        inSet: this.dataset.labelInSet || '[count]× in your set',
        remove: this.dataset.labelRemove || 'Remove [title]',
      };
      // Panel layout: a tile can go in more than once and the set shows as a wall. Grid layout: toggles.
      this.multi = this.hasAttribute('data-multi');
      this.selection = [];

      try {
        this.tiers = JSON.parse(this.querySelector('[data-bundle-tiers]').textContent) || [];
      } catch (e) {
        this.tiers = [];
      }
      this.tiers.sort((a, b) => a.min - b.min);

      this.countEl = this.querySelector('[data-bundle-count]');
      this.subtotalEl = this.querySelector('[data-bundle-subtotal]');
      this.progressEl = this.querySelector('[data-bundle-progress]');
      this.submitEl = this.querySelector('[data-bundle-submit]');
      this.wallEl = this.querySelector('[data-bundle-wall]');
      this.discountEl = this.querySelector('[data-bundle-discount]');
      this.discountRowEl = this.querySelector('[data-bundle-discount-row]');
      this.totalEl = this.querySelector('[data-bundle-total]');
      this.meterEl = this.querySelector('[data-bundle-meter]');

      this.querySelectorAll('[data-bundle-add]').forEach((btn) =>
        btn.addEventListener('click', () => this.toggle(btn))
      );
      if (this.submitEl) this.submitEl.addEventListener('click', () => this.submit());
      this.querySelectorAll('[data-bundle-filter]').forEach((chip) => chip.addEventListener('click', () => this.filter(chip)));

      this.update();
    }

    toggle(btn) {
      if (btn.hasAttribute('disabled')) return;
      const id = btn.dataset.variantId;
      const entry = { id: id, price: parseInt(btn.dataset.price, 10) || 0, title: btn.dataset.title || '', img: btn.dataset.img || '' };
      if (this.multi) {
        this.selection.push(entry);
        this.update(this.selection.length - 1);
        return;
      }
      const at = this.selection.findIndex((item) => item.id === id);
      if (at > -1) {
        this.selection.splice(at, 1);
        btn.setAttribute('aria-pressed', 'false');
        btn.querySelector('.bundle__add-label').textContent = this.labels.add;
      } else {
        this.selection.push(entry);
        btn.setAttribute('aria-pressed', 'true');
        btn.querySelector('.bundle__add-label').textContent = this.labels.chosen;
      }
      this.update();
    }

    remove(index) {
      this.selection.splice(index, 1);
      this.update();
      // the wall was rebuilt: keep keyboard focus on the next remove button (or the submit)
      const buttons = this.wallEl ? this.wallEl.querySelectorAll('.bundle__slot-rm') : [];
      (buttons[Math.min(index, buttons.length - 1)] || this.submitEl)?.focus();
    }

    // Exposed for testing: the preview for a count and subtotal (cents) against the tiers.
    static preview(tiers, count, subtotal) {
      let current = null;
      let next = null;
      tiers.forEach((t) => {
        if (count >= t.min) current = t;
        else if (next === null) next = t;
      });
      const discount = current && current.percent ? Math.round((subtotal * current.percent) / 100) : 0;
      return { current: current, next: next, discount: discount, total: subtotal - discount };
    }

    update(added) {
      const count = this.selection.length;
      const subtotal = this.selection.reduce((sum, item) => sum + item.price, 0);
      const plan = BundleBuilder.preview(this.tiers, count, subtotal);
      const money = (cents) => formatMoney(cents, this.moneyFormat);

      if (this.countEl) this.countEl.textContent = count;
      if (this.subtotalEl) this.subtotalEl.innerHTML = count || this.multi ? money(subtotal) : '';
      if (this.submitEl) this.submitEl.toggleAttribute('disabled', count < this.min);
      if (this.totalEl) this.totalEl.innerHTML = money(plan.total);
      if (this.discountEl) this.discountEl.innerHTML = '− ' + money(plan.discount);
      if (this.discountRowEl) this.discountRowEl.hidden = !plan.discount;
      if (this.meterEl) {
        const goal = (plan.next || plan.current || { min: this.min }).min;
        this.meterEl.style.width = Math.min(100, Math.round((count / goal) * 100)) + '%';
      }
      if (this.wallEl) this.renderWall(added);
      if (this.multi) {
        this.querySelectorAll('[data-bundle-item]').forEach((item) => {
          const btn = item.querySelector('[data-bundle-add]');
          const badge = item.querySelector('[data-bundle-in]');
          if (!btn || !badge) return;
          const n = this.selection.filter((entry) => entry.id === btn.dataset.variantId).length;
          badge.textContent = this.labels.inSet.replace('[count]', n);
          badge.hidden = !n;
        });
      }

      // Staffels markeren + voortgangstekst.
      const current = plan.current;
      const next = plan.next;
      this.querySelectorAll('[data-bundle-tier]').forEach((el) => {
        el.classList.toggle('is-reached', count >= parseInt(el.dataset.bundleTier, 10));
      });
      if (this.progressEl) {
        this.progressEl.classList.toggle('is-reached', !next && !!current);
        if (next) {
          const left = next.min - count;
          this.progressEl.textContent = this.labels.next.replace('[left]', left).replace('[label]', next.label);
        } else if (current) {
          this.progressEl.textContent = this.labels.top.replace('[label]', current.label);
        } else {
          this.progressEl.textContent = this.labels.min;
        }
      }
    }

    // The set as a tile wall: every pick as a slot, then empty slots up to the minimum (and one to grow).
    renderWall(added) {
      const icon = '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg>';
      const slots = this.selection.map((item, i) => {
        const slot = document.createElement('div');
        slot.className = 'bundle__slot' + (i === added ? ' is-new' : '');
        const img = document.createElement('img');
        img.src = item.img;
        img.alt = item.title;
        img.width = 120;
        img.height = 120;
        const rm = document.createElement('button');
        rm.type = 'button';
        rm.className = 'bundle__slot-rm';
        rm.setAttribute('aria-label', this.labels.remove.replace('[title]', item.title));
        rm.innerHTML = icon;
        rm.addEventListener('click', () => this.remove(i));
        slot.append(img, rm);
        return slot;
      });
      const empty = Math.max(this.min, this.selection.length + 1) - this.selection.length;
      for (let i = 0; i < empty; i++) {
        const slot = document.createElement('div');
        slot.className = 'bundle__slot bundle__slot--empty';
        slots.push(slot);
      }
      this.wallEl.replaceChildren(...slots);
    }

    filter(chip) {
      const handle = chip.dataset.bundleFilter;
      this.querySelectorAll('[data-bundle-filter]').forEach((c) => c.setAttribute('aria-pressed', String(c === chip)));
      this.querySelectorAll('[data-bundle-item]').forEach((item) => {
        item.hidden = !!handle && !(item.dataset.cols || '').split(',').includes(handle);
      });
    }

    async submit() {
      if (this.selection.length < this.min || this.submitting) return;
      this.submitting = true;
      this.submitEl.setAttribute('aria-busy', 'true');

      // one line per tile, a repeated pick raises its quantity
      const items = [];
      this.selection.forEach((entry) => {
        const line = items.find((item) => item.id === entry.id);
        if (line) line.quantity += 1;
        else items.push({ id: entry.id, quantity: 1, properties: { _bundle: this.bundleLabel } });
      });

      const hasDrawer = !!document.querySelector('cart-drawer');
      const body = JSON.stringify({
        items: items,
        sections: hasDrawer ? 'cart-drawer,cart-icon-bubble' : 'cart-icon-bubble',
        sections_url: window.location.pathname,
      });

      try {
        const config = typeof fetchConfig === 'function' ? fetchConfig() : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
        const notify =
          typeof dispatchCartLinesUpdate === 'function'
            ? dispatchCartLinesUpdate(this, 'add', items.map((item) => ({ merchandiseId: item.id, quantity: item.quantity })), 'product')
            : () => {};
        const res = await fetch(this.cartAddUrl, { ...config, body }).then((r) => r.json());

        if (res.status) {
          // Foutmelding van Shopify (bv. niet op voorraad), zichtbaar in de voortgangsregel
          if (this.progressEl && res.description) this.progressEl.textContent = res.description;
          this.submitting = false;
          this.submitEl.removeAttribute('aria-busy');
          return;
        }

        this.renderFromSections(res.sections);
        notify();
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'bundle-builder',
            cartData: res,
            cart: typeof cartStateFromSections === 'function' ? cartStateFromSections(res.sections) : null,
            drawerRendered: hasDrawer,
          });
        }

        if (hasDrawer) {
          const drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.open === 'function') drawer.open();
          this.reset();
        } else {
          window.location = this.cartUrl;
        }
      } catch (e) {
        console.error('[bundle-builder]', e);
        window.location = this.cartUrl;
      } finally {
        this.submitting = false;
        this.submitEl.removeAttribute('aria-busy');
      }
    }

    reset() {
      this.selection = [];
      if (this.multi) return this.update();
      this.querySelectorAll('[data-bundle-add]').forEach((btn) => {
        btn.setAttribute('aria-pressed', 'false');
        const label = btn.querySelector('.bundle__add-label');
        if (label) label.textContent = this.labels.add;
      });
      this.update();
    }

    renderFromSections(sections) {
      if (!sections) return;
      const parser = new DOMParser();
      if (sections['cart-drawer']) {
        const doc = parser.parseFromString(sections['cart-drawer'], 'text/html');
        const source = doc.querySelector('.drawer__inner');
        const target = document.querySelector('cart-drawer .drawer__inner');
        if (source && target) target.innerHTML = source.innerHTML;
      }
      if (sections['cart-icon-bubble']) {
        const doc = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
        const source = doc.querySelector('.shopify-section') || doc.body.firstElementChild;
        const target = document.getElementById('cart-icon-bubble');
        if (source && target) target.innerHTML = source.innerHTML;
      }
    }
  }

  if (!customElements.get('bundle-builder')) {
    customElements.define('bundle-builder', BundleBuilder);
  }
})();
